export const processData = doc => ({ ...doc.data(), id: doc.id })

export const processRecords = querySnapshot => {
  let records = []
  querySnapshot.forEach(doc => records.push(processData(doc)))
  return records
}
